export default "/assets/images/the-overreactor-crop.png?28548f5648f071d68f057169505044d7";